import {local} from 'wix-storage';
import wixWindow from 'wix-window';

$w.onReady(function () {
  // flag is not found
  if(!local.getItem("firstTimePopupShown")) {
    // open popup
    wixWindow.openLightbox("SubscribeBW");
    // set flag for future visits
    local.setItem("firstTimePopupShown", "yes");
  }
} );